module.exports = __webpack_public_path__ + "static/img/plate.bddd276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s33/pop/plate.png
// module id = 1O9a
// module chunks = 2